import Vue from "vue";
Vue.mixin({
  beforeRouteEnter(to, from, next) {
    document.title = to.meta.title;
    next();
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
});
